import { memo } from "react";
import LoadingOverlay from "./LoadingOverlay";
import { styled } from "@mui/material";
import {
  AutoRenderMessageOverlay,
  ManualRenderMessageOverlay
} from "./RenderMessageOverlay";

export interface ContentOverlayProps {
  messages: string[];
  time?: number;
  id: string;
  mode: "auto" | "manual";
  top?: string;
  static?: boolean;
}

export const ContentOverlay = memo((props: ContentOverlayProps) => {
  const { messages, id } = props;

  return (
    <Container id={props.id} style={{ height: props.static ? "100vh" : "100%" }}>
      <Content style={{ top: props.top }}>
        <LoadingOverlay />
        {props.mode == "manual" && <ManualRenderMessageOverlay id={id} />}
        {props.mode == "auto" && (
          <AutoRenderMessageOverlay time={props.time} messages={messages} />
        )}
      </Content>
    </Container>
  );
});

const Container = styled("div")`
  width: 100%;
  height: 100%;
  background-color: #ffffff99;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100000;
  @keyframes Loader_611 {
    0% {
      transform: rotate(0deg);
      transform-origin: right bottom;
    }

    25% {
      transform: rotate(90deg);
      transform-origin: right bottom;
    }

    50% {
      transform: rotate(180deg);
      transform-origin: right bottom;
    }

    75% {
      transform: rotate(270deg);
      transform-origin: right bottom;
    }

    100% {
      transform: rotate(360deg);
      transform-origin: right bottom;
    }
  }
`;

const Content = styled("div")`
  width: 75%;
  display: flex;
  position: absolute;
  /* top: 0; */
  flex-direction: column;
  justify-items: center;
  text-align: center;
  gap: 50px;
  .text-title {
    background-color: #ffffff99;
    border-radius: 10px;
    line-height: 1.5;
    padding: 10px;
  }
`;
